<div class="view-all-notification-modal" data-testid="focus-notification-viewall-modal-root">
    <div class="modal-header" data-testid="focus-notification-viewall-modal-header-root">
        <div class="modal-title-container">
            <span class="modal-icon">
                <img src="../../../../../../assets/images/client-messaging/bellWithRedDot.svg"
                    alt="Notifications Icon" />
            </span>
            <div class="title" data-testid="focus-notification-viewall-modal-title">Notifications</div>
        </div>
        <button class="close-button" data-testid="focus-notification-viewall-modal-closebtn-oncancel" (click)="onCancel()" aria-label="Close">
            <img src="../../../../../../assets/images/client-messaging/cross.svg" alt="Close" />
        </button>
    </div>

    <div class="modal-body" data-testid="focus-notification-viewall-modal-body-root">
        <div class="container-wrapper">
            <div class="dropdowns-container">
                <!-- Viewing Dropdown with ng-select -->
                <div class="dropdown-group">
                    <label for="viewingSelect" class="sr-only">Viewing Options</label>
                    <ng-select id="viewingSelect" data-testid="focus-notification-viewall-modal-viewing-select" [(ngModel)]="selectedViewing" (change)="onViewingChange($event)"
                        class="select-style" [items]="viewingOptions" bindLabel="label" bindValue="value"
                        [multiple]="false" [searchable]="false" [clearable]="false"
                        placeholder="Viewing: Select an option">
                        <!-- Custom template for the selected value (single-select) -->
                        <ng-template ng-label-tmp let-item="item">
                            <div class="custom-selected-value">
                                Viewing: <span class="highlight">{{ item.label }}</span>
                            </div>
                        </ng-template>
                        <!-- Custom template for dropdown options -->
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option">
                                {{ item.label }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>

                <!-- Sort By Dropdown with ng-select -->
                <div class="dropdown-group">
                    <label for="sortSelect" class="sr-only">Sort By Options</label>
                    <ng-select id="sortSelect" data-testid="focus-notification-viewall-modal-sort-select" [(ngModel)]="selectedSort" (change)="onSortChange($event)"
                        class="select-style" [items]="sortOptions" bindLabel="label" bindValue="value"
                        [multiple]="false" [searchable]="false" [clearable]="false"
                        placeholder="Sort By: Select an option">
                        <!-- Custom template for the selected value (single-select) -->
                        <ng-template ng-label-tmp let-item="item">
                            <div class="custom-selected-value">
                                Sort By: <span class="highlight">{{ item.label }}</span>
                            </div>
                        </ng-template>
                        <!-- Custom template for dropdown options -->
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option">
                                {{ item.label }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>

                <!-- Refresh Button -->
                <div class="refresh" data-testid="focus-notification-viewall-modal-refreshbtn-refreshnotifications" (click)="refreshNotifications()">
                    <i class="fa fa-refresh" aria-hidden="true" height="20" width="20"></i>
                </div>
            </div>

            <!-- Notification Text -->
            <p class="notification-text" data-testid="focus-notification-viewall-modal-message">Notifications available of past 5 days only.</p>
        </div>
        <div class="notification-list" data-testid="focus-notification-viewall-modal-list" [appLoading]="isLoading" >
            <div *ngIf="notifications.length === 0" class="no-notifications" data-testid="focus-notification-viewall-modal-empty-root">
                <div class="col-sm-12" style="padding: 20px 15px; margin-bottom: 20px; text-align: center;">
                    <img src="../../../../../assets/images/Upfront Icon/Empty1.svg" style="width: 80px;" />
                    <p data-testid="focus-notification-viewall-modal-empty-message" style="color: #75787B; font-size: 20px; margin-top: 20px;">
                        No notifications.
                    </p>
                </div>
            </div>
            <div *ngFor="let notification of notifications" class="notification-item" data-testid="focus-notification-viewall-modal-item" [class.read]="notification.read" [class.standard-notification-item]="notification.type !== 'task_note_tagged'" (click)="openMyConversation(notification)" >
                <img [src]="notification.type === 'follow' ? '/assets/images/client-messaging/FollowerAdded.svg' :notification.user.avatar" alt="User Avatar" class="notification-avatar" data-testid="focus-notification-viewall-modal-item-avatar" />
                <div class="notification-content">
                    <ng-container *ngIf="notification.type !== 'task_note_tagged'; else taskNoteTaggedTemplate">
                        <div class="notification-meta">
                            <span class="notification-user-name" data-testid="focus-notification-viewall-modal-item-username-value">{{ notification.type === 'follow' ? 'Follow' : notification.user.name }}</span>
                            <span class="notification-type" data-testid="focus-notification-viewall-modal-item-type-incomingsms-value" *ngIf="notification.type === 'incoming_sms'">Incoming Text</span>
                            <span class="notification-type" data-testid="focus-notification-viewall-modal-item-type-incomingemail-value" *ngIf="notification.type === 'incoming_email'">Incoming Email</span>
                            <span class="notification-type" data-testid="focus-notification-viewall-modal-item-type-follow-value" *ngIf="notification.type === 'follow'">Follower Added</span>
                        </div>
                        <p class="notification-message" data-testid="focus-notification-viewall-modal-item-message-value" *ngIf="notification.message">
                            <span *ngIf="notification.type === 'incoming_email'" class="font-medium" >Subject:
                                <span [innerHTML]="
                                notification.subject && notification.subject.length > 30
                                ? (notification.subject | slice: 0:30) + '...'
                                : notification.subject
                                "></span>
                             </span>
                            <span class="message" [innerHTML]=" notification.message.length > 60 ? (notification.message | slice: 0:60) + '...': notification.message"></span>
                        </p>
                        <div class="message attachment-preview" data-testid="focus-notification-viewall-modal-item-attachment-value" *ngIf="notification.hasAttachment && !notification.message">
                            <i class="fa fa-paperclip attachment-icon"></i>
                            <span>Attachment</span>
                        </div>
                        <span class="notification-time" data-testid="focus-notification-viewall-modal-item-time-value">
                            <img src="/assets/images/client-messaging/time.svg" alt="Time icon" />
                            {{ notification.timeAgo }}
                        </span>
                    </ng-container>

                    <ng-template #taskNoteTaggedTemplate>
                        <div class="task-note-tagged-header">
                            <div class="notification-meta">
                                <span class="notification-user-name" data-testid="focus-notification-viewall-modal-item-tasknote-username-value">{{ notification.patientName || notification.user.name }}</span>
                                <span class="notification-type" data-testid="focus-notification-viewall-modal-item-type-tasknotetagged-value">Task Note Tagged</span>
                            </div>
                        </div>
                        <p class="task-note-tagged-task" data-testid="focus-notification-viewall-modal-item-tasknote-task-value" *ngIf="notification.taskNoteTaggedMeta?.taskName">
                            Task: {{ notification.taskNoteTaggedMeta?.taskName }}
                        </p>
                        <p class="task-note-tagged-label" data-testid="focus-notification-viewall-modal-item-tasknote-label">
                            {{ (notification.taskNoteTaggedMeta?.username || 'Someone') | titlecase }} tagged you in a note:
                        </p>
                        <p class="task-note-tagged-note" data-testid="focus-notification-viewall-modal-item-tasknote-note-value" *ngIf="notification.taskNoteTaggedMeta?.noteSnippet || notification.message"
                            [title]="getTaggedNoteFullText(notification.taskNoteTaggedMeta?.noteSnippet, notification.message)">
                            "<span [innerHTML]="getTaggedNotePreview(notification.taskNoteTaggedMeta?.noteSnippet, notification.message)"></span>"
                        </p>
                        <span class="task-note-tagged-queue" data-testid="focus-notification-viewall-modal-item-tasknote-queue-value" *ngIf="notification.taskNoteTaggedMeta?.queueName">
                            Queue: {{ notification.taskNoteTaggedMeta?.queueName }}
                        </span>
                        <span class="task-note-tagged-time" data-testid="focus-notification-viewall-modal-item-tasknote-time-value">
                            <img src="/assets/images/client-messaging/time.svg" alt="Time icon" />
                            {{ notification.timeAgo }}
                        </span>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer" data-testid="focus-notification-viewall-modal-footer-root">
        <span class="page-info" data-testid="focus-notification-viewall-modal-page-info" *ngIf="notifications.length !== 0">Showing
            {{ (paginationConfig.currentPage - 1) * itemsPerPage + 1 }} to
            {{
            paginationConfig.currentPage * itemsPerPage > totalItems
            ? totalItems
            : paginationConfig.currentPage * itemsPerPage
            }}
            of {{ totalItems }} entries</span>
        <app-pagination data-testid="focus-notification-viewall-modal-onpagechange-pagination" [config]="paginationConfig" [total]="totalItems" [limit]="itemsPerPage"
            [pageObject]="pageObject" (pageChange)="onPageChange($event)" [custompageInfo]="false">
        </app-pagination>
    </div>
</div>